import {useEffect, useRef} from 'react';

function useIntersectionObserver(
  handler: (entry: IntersectionObserverEntry, observer: IntersectionObserver) => void,
  options: IntersectionObserverInit = {}
) {
  const observerRef = useRef(null);
  const observer = new IntersectionObserver(([entry], observer) => {
    handler(entry, observer);
  }, options);

  useEffect(() => {
    const target = observerRef.current;
    if (target) {
      observer.observe(target);
    }

    return () => {
      if (target) {
        observer.unobserve(target);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [handler, options]);

  return {observerRef, observer};
}

export default useIntersectionObserver;
